"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapImageCenterBounds = void 0;
var react_leaflet_1 = require("react-leaflet");
var MapImageCenterBounds = function (_a) {
    var image_ref = _a.image_ref, map_height = _a.map_height, map_width = _a.map_width;
    var map = (0, react_leaflet_1.useMap)();
    if (image_ref.current && !image_ref.current.bounds_fit) {
        map.fitBounds([
            [-10, -10],
            [map_height + 10, map_width + 10],
        ]);
        image_ref.current.bounds_fit = true;
    }
    return null;
};
exports.MapImageCenterBounds = MapImageCenterBounds;
